import { render, staticRenderFns } from "./ScoreTable.vue?vue&type=template&id=3c50e1e7&scoped=true&"
import script from "./ScoreTable.vue?vue&type=script&lang=js&"
export * from "./ScoreTable.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTable.vue?vue&type=style&index=0&id=3c50e1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50e1e7",
  null
  
)

export default component.exports